(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    // New code to handle transparency and logo change
    //const logoMotionReduce = this.header.querySelector('img.header__heading-logo.motion-reduce');
    //const stickyNavLogo = this.header.querySelector('.sticky-nav-logo');

    //if (scrollTop > 300) {
    //  this.header.classList.add('header-colored');
    //  if (logoMotionReduce) logoMotionReduce.style.display = 'none';
    //  if (stickyNavLogo) stickyNavLogo.style.display = 'block';
    //} else {
    //  this.header.classList.remove('header-colored');
    //  if (logoMotionReduce) logoMotionReduce.style.display = 'block';
    //  if (stickyNavLogo) stickyNavLogo.style.display = 'none';
   // }

   // this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-article"]) return;
  try {
    
(() => {
  const isMedia = element => element && !element.matches('.journal-pair,.journal-image-text,.journal-wide') && (element.matches('figure,.captioned-image-container') || element.matches('p') && element.querySelector('img')) && element.querySelectorAll('img').length === 1;
  function arrange(article) {
    const body = article.querySelector('[data-journal-native-body]');
    if (body) {
      for (const figure of body.querySelectorAll('figure')) {
        const images = figure.querySelectorAll('img');
        if (images.length !== 1) continue;
        let caption = figure.querySelector('figcaption,.image-caption');
        if (caption && caption.textContent.trim()) {
          figure.append(caption);
          continue;
        }
        const description = (images[0].getAttribute('alt') || '').trim();
        if (!description) continue;
        if (!caption) caption = document.createElement('figcaption');
        caption.textContent = description;
        figure.append(caption);
      }
    }
    if (!body || body.dataset.autoLayout === 'false' || body.dataset.layoutApplied === 'true') return;
    body.dataset.layoutApplied = 'true';
    const custom = article.dataset.journalDesign === 'custom';
    if (custom) {
      const first = body.firstElementChild;
      if (isMedia(first)) first.classList.add('journal-wide', 'journal-native-hero');
      for (const paragraph of Array.from(body.children)) {
        if (!paragraph.matches('p') || !paragraph.querySelector('em,i') || paragraph.querySelector('img')) continue;
        const value = paragraph.textContent.trim();
        if (!/^[“"‘]/.test(value) || !/[”"’][.!?]?$/.test(value)) continue;
        const quote = document.createElement('blockquote');
        paragraph.replaceWith(quote);
        quote.append(paragraph);
      }
      for (const quote of Array.from(body.children).filter(element => element.matches('blockquote'))) {
        const image = quote.previousElementSibling;
        if (!isMedia(image)) continue;
        const paragraphs = [];
        let previous = image.previousElementSibling;
        while (previous && previous.matches('p') && !previous.querySelector('img')) {
          paragraphs.unshift(previous);
          previous = previous.previousElementSibling;
        }
        if (!paragraphs.length) continue;
        const row = document.createElement('div');
        row.className = 'journal-image-text';
        const copy = document.createElement('div');
        copy.className = 'journal-native-text';
        paragraphs[0].before(row);
        row.append(copy);
        paragraphs.forEach(paragraph => copy.append(paragraph));
        row.append(image);
      }
    }
    const children = Array.from(body.children);
    for (let index = 0; index < children.length; index++) {
      if (!isMedia(children[index])) continue;
      const run = [];
      while (index < children.length && isMedia(children[index])) run.push(children[index++]);
      index--;
      const start = run.length > 2 ? 1 : 0;
      for (let offset = start; offset + 1 < run.length; offset += 2) {
        const pair = document.createElement('div');
        pair.className = 'journal-pair';
        run[offset].before(pair);
        pair.append(run[offset], run[offset + 1]);
      }
    }
  }
  const initialize = scope => scope.querySelectorAll('[data-journal-design]').forEach(arrange);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
